module.exports = __webpack_public_path__ + "05_medium_black.d8d78116.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/05_medium_black.png
// module id = pILh
// module chunks = 0